
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fraud/result",
      function () {
        return require("private-next-pages/fraud/result.tsx");
      }
    ]);
  